"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _clsx4 = _interopRequireDefault(require("clsx"));
var _Container = _interopRequireDefault(require("../Container"));
var _context = _interopRequireDefault(require("../Theme/context"));
var _context2 = _interopRequireDefault(require("./context"));
var _excluded = ["classNames", "defaultClassName", "children", "autoContrast", "disabled"],
  _excluded2 = ["variant", "color"];
var defaultStyle = require("./../empty_css.js")["default"];
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _useContext = (0, _react.useContext)(_context["default"]),
    componentsStyle = _useContext.componentsStyle,
    useStyle = _useContext.useStyle;
  var colorContext = (0, _react.useContext)(_context2["default"]);
  var _props$classNames = props.classNames,
    classNames = _props$classNames === void 0 ? componentsStyle || defaultStyle : _props$classNames,
    _props$defaultClassNa = props.defaultClassName,
    defaultClassName = _props$defaultClassNa === void 0 ? '' : _props$defaultClassNa,
    _props$children = props.children,
    children = _props$children === void 0 ? null : _props$children,
    _props$autoContrast = props.autoContrast,
    autoContrast = _props$autoContrast === void 0 ? false : _props$autoContrast,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    rest2 = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _rest2$variant = rest2.variant,
    variant = _rest2$variant === void 0 ? 'paper' : _rest2$variant,
    _rest2$color = rest2.color,
    color = _rest2$color === void 0 ? colorContext.color : _rest2$color,
    rest = (0, _objectWithoutProperties2["default"])(rest2, _excluded2);
  variant = variant === 'inherit' ? colorContext.variant : variant;
  if (classNames !== componentsStyle) {
    if (typeof useStyle === 'function') {
      useStyle(classNames);
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_context2["default"].Provider, {
    value: {
      color: color,
      variant: variant
    }
  }, /*#__PURE__*/_react["default"].createElement(_Container["default"], Object.assign({}, rest, {
    ref: ref,
    defaultClassName: (0, _clsx4["default"])(classNames['color-' + color], (0, _defineProperty2["default"])({}, classNames['color-disabled'], disabled && classNames['color-disabled']), classNames.color, (0, _defineProperty2["default"])({}, classNames.colorAutoContrast, autoContrast), (0, _defineProperty2["default"])({}, classNames['color-' + variant], variant && classNames['color-' + variant]), defaultClassName)
  }, disabled ? {
    disabled: disabled
  } : {}), children));
});